/* 加载js文件
 opts.url: js路径
 opts.params 路径携带参数
 opts.loadRemove 自动移除创建的script
*/
export const script = (opts = {}) => {
  let options = {
    url: '',
    params: {},
    loadRemove: true,
  };
  options = Object.assign(true, options, opts);
  // 请求参数
  let queryStr = '';
  const script = window.document.createElement('script');
  script.async = 'async';
  for (const query in options.params) {
    queryStr += `${query}=${options.params[query]}&`;
  }
  if (queryStr) {
    queryStr = queryStr.slice(0, -1);
    if (options.url.lastIndexOf('&') === options.url.length - 1) {
      options.url += queryStr;
    } else {
      options.url += `&${queryStr}`;
    }
  }
  script.src = options.url;
  return new Promise((resolve, reject) => {
    const headEl = window.document.getElementsByTagName('head')[0];
    script.onload = script.onreadystatechange = function (event) {
      if ([undefined, 'loaded', 'complete'].indexOf(this.readyState) > -1) {
        if (options.loadRemove) {
          script.onload = null;
          headEl.removeChild(script);
        }
        script.onreadystatechange = null;
        resolve();
        return;
      }
      reject(new Error(event));
    };
    script.onerror = reject;
    headEl.appendChild(script);
  });
};
